import { Component, OnInit } from '@angular/core';
import { TBinaryComponent } from '../t-binary/t-binary.component';
import { TopicService } from '../topic.service';
import { ActivatedRoute } from '@angular/router';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-t-binary-search',
  templateUrl: './t-binary-search.component.html',
  styleUrls: ['./t-binary-search.component.css']
})
export class TBinarySearchComponent extends TBinaryComponent{

  constructor(protected topicService: TopicService, protected activatedRoute:ActivatedRoute, protected http: HttpClient) {
    super(topicService, activatedRoute, http);
    this.type = "binarySearch";
    this.title = this.get("binarySearchTitle");
   }

}
